var Aneox;
(function(Aneox) {
    'use strict';

    var App = (function() {

        var isTouchDevice;

        var currentLocale;
        var currentNode;
        var currentController;

        function App(fonts, locale, router, analytics, homeController, companyController, vineyardController, vineyardDetailsController, producersController, contactController, legalController) {
            
            
            this.fonts = fonts;
            this.locale = locale;
            this.router = router;
            this.analytics = analytics;
            this.controllers = {
                home: homeController,
                company: companyController,
                vineyard: vineyardController,
                vineyardDetails: vineyardDetailsController,
                producers: producersController,
                contact: contactController,
                legal: legalController
            };
            
            
            var self = this;
            self.geographyData;
            self.producersData;
            self.localeProducersData;
            self.letterData;
            self.instagramData;
            self.byPassBot = false;
            
            var md = new MobileDetect(window.navigator.userAgent);
            Aneox.Data.Config.runtime = {
                isTouchDevice: 'ontouchstart' in document.documentElement,
                mobile: md.mobile(),
                supportsScrollEvents: !md.mobile() || (md.is('iOS') && md.is('Safari') && md.version('Safari') > 8)
            };

            lazySizesConfig.preloadAfterLoad = true;
            
            

            
            
            $(document).on("dataLoaded", function(event){
             
                TweenMax.to('#loading', 0.5, { opacity: 0, display: 'none' });
                 
                 // Routes that are fetched from CMS
                //self.router.deferredRoutes = function(callback) {
                    
                    var tempProducerData = _.partition(self.producersData, function(a){
                        return a.id == a.translationNid;
                    });
                    
                    _.forEach(tempProducerData[0], function(producer){
                        Aneox.Data.Nodes.nodes.push({
                            id: producer.id,
                            type: 'producer-page',
                            locales: [{
                                locale: producer.local,
                                description: producer.name+' : '+producer.description,
                                path: '/vignerons' + producer.path,
                                title: 'Mouchonnat : '+ producer.name
                            }]
                        });
                    });
                    
                    _.forEach(tempProducerData[1], function(producer){
                        var node = _.find(Aneox.Data.Nodes.nodes,{'id': producer.translationNid});
                        
                        if(!_.isEmpty(node)){
                            node.locales.push({
                                    locale: producer.local,
                                    description: producer.name+' : '+producer.description,
                                    path: '/winemakers/' + _.kebabCase(producer.name),
                                    title: 'Mouchonnat : '+ producer.name
                            });
                        }
                        

                    });
                    
                    //console.log(Aneox.Data.Nodes.nodes);
                    //callback();
                //};
                //console.log("self.router.init();");
                self.router.init();
                //setTimeout(self.router.init.bind(self.router));
                

                var throttledWindowResizeHandler = _.throttle(handleWindowResize, 500, { leading: false, trailing: true });
                $(window).resize(throttledWindowResizeHandler);
                Visibility.change(throttledWindowResizeHandler);
                self.fonts.bind('fontsActive', handleWindowResize);
                handleWindowResize();

                // Scroll handling
                $(window).on('scroll', function (event) {
                    if (currentController && currentController.handleScroll) currentController.handleScroll.call(currentController, event); 
                });

            });
            
            
            self.router.bind('pageChange', function(path, node, nodeLocale) {
                self.localeProducersData = _.filter(self.producersData, {'local': nodeLocale.locale});
                self.controllers.producers.producersData = self.localeProducersData;
                self.controllers.vineyardDetails.producersData = self.localeProducersData;
                self.controllers.home.producersData = self.localeProducersData;
                self.controllers.home.instagramData = self.instagramData;
                
                self.locale.setLocale(nodeLocale.locale);
                if (_.get(currentNode, 'id') === node.id) return;
                //self.producersData = _.filter(self.producersData, {'local': nodeLocale.locale});
                
                setAvailableGeography();
                
                var rootNodeId, controllerId;
                
                // Enter/Leave animations
                if (_.get(currentNode, 'id') !== node.id) {
                    switch (_.get(currentNode, 'type')) {
                        case 'vineyard-details':
                            self.controllers.vineyardDetails.leave();
                            break;
                        case 'producer-page':
                            if (node.type === 'producer-page') break;
                            self.controllers.producers.leave();
                            break;
                        case 'basic-page':
                            self.controllers[currentNode.id].leave();
                            break;
                    }
                    
                    switch (node.type) {
                        case 'vineyard-details':

                            if (Cookies.get('splashscreen') == 'true' || self.byPassBot === true){
                                self.controllers.vineyardDetails.enter(node.id);
                            }else{
                                $(document).bind("acceptSplash", function(event){
                                   currentController.enter(currentNode.id);
                                });
                            } 

                            rootNodeId = 'vineyard';
                            controllerId = 'vineyardDetails';
                            break;
                        case 'producer-page':

                            if(Cookies.get('splashscreen') == 'true' || self.byPassBot === true){
                                if (_.get(currentNode, 'type') !== 'producer-page')self.controllers.producers.enter(node.id); 
                                else self.controllers.producers.swap(node.id);
                            }else{
                                $(document).bind("acceptSplash", function(event){
                                    currentController.enter(currentNode.id);
                                });
                            }

                            rootNodeId = 'producers';
                            controllerId = 'producers';
                            break;
                        default:
                            if (Cookies.get('splashscreen') == 'true' || self.byPassBot === true){
                                self.controllers[node.id].enter();
                            }else{
                                $(document).bind("acceptSplash", function(event){
                                    currentController.enter();
                                });
                            } 
                            rootNodeId = node.id;
                            controllerId = node.id;
                            break;
                    }
                }

                // Update active menu item
                $('#nav-menu ul li').removeClass('active');
                $('#nav-menu ul li a[router-href="' + rootNodeId + '"]').parent().addClass('active');

                currentNode = node;
                currentController = self.controllers[controllerId];
            });

            self.locale.bind('localeChange', function(locale) {
               
                if (currentLocale === locale) return;
               
                if(!_.isEmpty(currentNode)){
                     switch(currentNode.type){
                         case 'producer-page':
                            self.controllers.producers.swap(currentNode.id);
                            break;
                    }   
                } 
                
                $('#aside-languages li, #splash-languages li').removeClass('active');
                $('#aside-languages li a[router-locale="' + locale + '"], #splash-languages li a[router-locale="' + locale + '"]').parent().addClass('active');

                currentLocale = locale;

                setTimeout(handleWindowResize);
                self.router.reparseAnchors();
            });
            
            
            var checkCookiesSpash = function(){

            };
            
            
            // Window resize handling
            var handleWindowResize = function() {
                var screenWidth = _.get(window, 'screen.width', 0);
                var screenHeight = _.get(window, 'screen.height', 0);
                var maxScreenSize = Math.max(screenWidth, screenHeight);
                var screenOrientation = _.get(window, 'orientation', 0);
                var isPortrait = screenOrientation === 0 || screenOrientation === 180 || screenOrientation === -180;
                //console.log(Aneox.Data.Config.runtime.mobile);
                if (Aneox.Data.Config.runtime.mobile && (maxScreenSize <= 768 || (isPortrait && screenWidth <= 768))) {
                    window.location.href = window.location.host.indexOf('mouchonnat.com') === -1 ? '/mobile.mouchonnat.com/' : 'http://mobile.mouchonnat.com/';
                }

                var windowHeight = $(window).height();

                _.forEach($('[screen-height]'), function(element) {
                    var heightElement = $(element);
                    var topMargin = _.parseInt(heightElement.css('margin-top'));
                    var bottomMargin = _.parseInt(heightElement.css('margin-top'));
                    var height = windowHeight - topMargin - bottomMargin;

                    heightElement.innerHeight(height);
                });

                if (currentController && currentController.handleWindowResize) currentController.handleWindowResize.call(currentController);
            };
            
            
            var getData = function(){
                
                
                    var basePath = $('head base').attr('href');
                
                    $.get('api/letter.json?display_id=services_1', function(data){
                    self.letterData = data.map(function(a){
                        return {
                            "letter": a.letter,
                            "tid": _.parseInt(a.tid) 
                        }
                    });
                    
                    $.get('api/geography.json?display_id=services_1', function (data) {
                        
                        $('#producers-list-vineyard-menu ul').empty();

                        self.geographyData = data.map(function(a, b){
                            return {"name": a.name, 
                                    'parent_tid': (!_.isEmpty(a.parent_tid)) ? _.parseInt(a.parent_tid) : 0, 
                                    "tid": _.parseInt(a.tid), 
                                    "svgId": a.svgid.value
                                   }
                        });
                        
                        
                        
                        //var vineyards = self.geographyData.filter( {"parent_tid": 0}).sortBy("name").sortedUniq().value();
                        /*var vineyards = _.chain(self.geographyData).filter({"parent_tid": 0}).sortBy("name").sortedUniq().value();
                       
                        
                        _.forEach(vineyards, function (vineyard) {

                            $('#producers-list-vineyard-menu ul').append('<li><a router-href="producers" onclick="app.controllers.producers.setFilter(\'vineyard\', \'' + _.parseInt(vineyard.tid) + '\', \'' + _.parseInt(vineyard.parent_tid) + '\', \'' + vineyard.name + '\')">' + vineyard.name + '</a></li>');
                        });

                        self.router.reparseAnchors();*/
                        
                        $.get('api/producers_v2.json?display_id=services_1', function (data){
                            
                            self.producersData = data.map(function(a){
                              
                                var zoneTid = _.parseInt(a.zone.tid);
                                var letterTid = _.parseInt(a.letter.tid);
                                
                                //console.log(zoneTid);
                                
                                if(zoneTid){
                                    var village = _.chain(self.geographyData).find({"tid": zoneTid}).value();    
                                }else{
                                    var village = {name: ''};
                                }
                               
                                //console.log(village);
                                
                                if(village.parent_tid !== 0){
                                    var area = _.chain(self.geographyData).find({"tid": village.parent_tid}).value();    
                                }else{
                                    var area = {name: ''};
                                }
                                
                                //console.log(area);
                                
                                if(area.parent_tid !== 0 && area.name !== ''){
                                    var vineyard = _.chain(self.geographyData).find({"tid": area.parent_tid}).value();    
                                }else{
                                    var vineyard = {name: ''};
                                }

                                
                                //console.log(vineyard);
                                
                                var letter = _.find(self.letterData, {"tid": letterTid});
                                var htmlName = (a.title_1 != "" ? "<small>"+a.title_1+"</small> "+ a.title_2 : a.title_2 );
                                var path = _.replace(a.path, basePath, '/');
                                

                                return {
                                    "id": a.nid,
                                    "letter": letter.letter,
                                    "name": a.name,
                                    "htmlName": htmlName ,
                                    "village": village.name,
                                    "area": area.name,
                                    "vineyard": vineyard.name,
                                    "label" : a.etiquette,
                                    "image": a.portrait_carre,
                                    "imageLarge": a.portrait_large,
                                    "imageMobile": a.portrait_mobile,
                                    "quote" : a.quote,
                                    "description" : a.description,
                                    "path": path,
                                    "local": a.local,
                                    "translationNid": a.translationNid,
                                    "vineyardTid": area.parent_tid,
                                    "areaTid": village.parent_tid,
                                    "villageTid": zoneTid,
                                    "home": a.home
                                };
                            });
                            
                            //console.log(self.producersData);
                            
                            $.get('api/flux_instagram.json?display_id=services_1', function(data){
                                self.instagramData = data.map(function(a){
                                    return {
                                        "image": a.image,
                                        "hashtag": a.hashtag
                                    }
                                });

                                $(document).trigger('dataLoaded');
                            });
                        });
                        
                    });
                });
            };
            
            var setAvailableGeography = function(){
                
                var geographyProducer = _.chain(self.producersData).map(function(a){
                    return {
                        "vineyardTid": a.vineyardTid,
                        "areaTid": a.areaTid,
                        "villageTid": a.villageTid
                    };
                }).value();
                
                var geographyProducer = _.chain(geographyProducer).transform(function(result, value, key){
                   
                    result.push(value.vineyardTid);
                    result.push(value.areaTid);
                    result.push(value.villageTid);
                }, []).uniq().value();
                
                var tempGeographyData = [];
                _.forEach(self.geographyData, function(value, key){
                    var dataTid = _.parseInt(value.tid);
                   
                    var available =  _.find(geographyProducer, function(a){
                        return a == dataTid;
                    });
                    
                    if(available){
                        var vineyard = _.chain(self.localeProducersData).filter({'vineyardTid': dataTid}).value();
                        var area = _.chain(self.localeProducersData).filter({'areaTid': dataTid}).value();
                        var village = _.chain(self.localeProducersData).filter({'villageTid': dataTid}).value();
                        
                        if(vineyard || area || village) {
                            _.assign(value, {"vineyardCount": vineyard.length}, {"areaCount": area.length}, {"villageCount": village.length});
                        } 
                        
                        tempGeographyData.push(value);
                    }
                });
                
                self.geographyData = tempGeographyData; 
            }

            
            //TweenMax.set("#loading-mast i", { opacity: 0});
            
            //TweenMax.to("#loading-mast i:eq(0)", 0.5, { opacity: 1, repeatDelay: 0,  repeat: -1 });
            //TweenMax.to("#loading-mast i:eq(1)", 0.5, { opacity: 1, repeatDelay: 0.5, repeat: -1 }, 0.5);
            //TweenMax.to("#loading-mast i:eq(2)", 0.5, { opacity: 1, repeatDelay: 1, repeat: -1 }, 1);
            //TweenMax.to("#loading-mast i", 0.5, { opacity: 0, repeatDelay: 6, yoyo:true, repeat: -1 }, 1.5);
            //TweenMax.staggerTo("#loading-mast i", 0.5, { opacity: 1, repeatDelay: 0.5, repeat: -1 }, 0.5);
            
            
            var botAgent = "(bot|google|aolbuild|baidu|bing|msn|duckduckgo|teoma|slurp|yandex|Prerender)";
           
            var re = new RegExp(botAgent, 'i');
            var bot = re.test(navigator.userAgent);
            
            if (Cookies.get('splashscreen') !== 'true' && bot === false) {
                var now = new Date();
                now.setFullYear(now.getFullYear() - 18);
                var nowText = now.toISOString().substring(0, 10).split('-');
                $('#splashscreen-mast .date').text(nowText[2] + '/' + nowText[1] + '/' + nowText[0]);
                TweenMax.set('#splashscreen', { display: 'block', opacity: 1 });
                //TweenMax.fromTo('#splashscreen-mast', 0.5, { display: 'block', opacity: 0 }, { opacity: 1 });
            }else{
                self.byPassBot = true
            }
            
            

            getData();

        };
        
        App.prototype.acceptSplash = function() {
            //console.log("acceptSplash");
            Cookies.set('splashscreen', 'true');
            TweenMax.to('#splashscreen', 0.5, { opacity: 0, display: 'none' });
            //TweenMax.call(function(){
                $(document).trigger("acceptSplash");
            //});
        };

        App.prototype.refuseSplash = function() {
            window.location.href = 'https://google.fr';
        };
        

        return App;
    })();

    Aneox.App = App;
})(Aneox || (Aneox = {}));